
import Container = createjs.Container;

export class DispHelper {
    public static removeAllChildrenOf(disp: Container): void {
        while (disp.numChildren > 0) {
            disp.removeChildAt(0);
        }
    }
}
